import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { MessageViewModel, MESSAGE_DISPLAY_FIELD } from './+state';
import { MessageConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = MessageConstants;

@Injectable({providedIn: 'root'})
export class MessageService extends BaseService<MessageViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Message', RT.defaultApi)), MESSAGE_DISPLAY_FIELD);
  }
}
